import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Skeleton,
  Slide,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import useApiVersion from "../../hooks/useApiVersion";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = { open: boolean; onClose: () => void };

const VersionDialog = ({ open, onClose }: Props) => {
  const { data, status } = useApiVersion(open);

  return (
    <Dialog open={open} onClose={onClose} slots={{ transition: Transition }}>
      <DialogTitle>Build Information</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Frontend
        </Typography>
        <Typography variant="body2">
          Version {import.meta.env.VITE_VERSION}
        </Typography>
        <Typography variant="body2">
          Commit {import.meta.env.VITE_COMMIT}
        </Typography>
        <Typography variant="body2">
          Branch {import.meta.env.VITE_BRANCH}
        </Typography>
        <Typography variant="body2" gutterBottom>
          Built {import.meta.env.VITE_BUILD_DATE}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 2 }}>
          Backend
        </Typography>
        {status === "pending" ? (
          <Skeleton variant="text" width={120} />
        ) : (
          <Box>
            <Typography variant="body2">Version {data?.version}</Typography>
            <Typography variant="body2">Commit {data?.commit}</Typography>
            <Typography variant="body2">Branch {data?.branch}</Typography>
            <Typography variant="body2">Built {data?.buildDate}</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" endIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionDialog;
